import {createAction, props} from '@ngrx/store';

// request-maintenance.actions.ts
export const openPolicy = createAction('[PC] Open Policy', props<{ locationId: string }>());
export const openPolicySuccess = createAction('[PC] Open Policy Success',
  props<{ policy: { id: string; name: string; content?: string }, locationId: string }>());
export const openPolicyFailure = createAction('[PC] Open Policy Failure');

export const request = createAction('[PC] Request', props<{ locationId: string; policyId: string }>());
export const requestSuccess = createAction(
  '[RequestMaintenance] Request Success');

export const requestFailure = createAction(
  '[RequestMaintenance] Request Failure',
  props<{ errorKey: string; rawMessage?: string | null }>()
);

export const confirmPolicy = createAction('[PC] Confirm Policy',
  props<{ accepted: boolean; locationId: string; policyId: string }>());
